import { render, staticRenderFns } from "./tagManagement.vue?vue&type=template&id=ea2afb8e&scoped=true"
import script from "./tagManagement.vue?vue&type=script&lang=js"
export * from "./tagManagement.vue?vue&type=script&lang=js"
import style0 from "./tagManagement.vue?vue&type=style&index=0&id=ea2afb8e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2afb8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea2afb8e')) {
      api.createRecord('ea2afb8e', component.options)
    } else {
      api.reload('ea2afb8e', component.options)
    }
    module.hot.accept("./tagManagement.vue?vue&type=template&id=ea2afb8e&scoped=true", function () {
      api.rerender('ea2afb8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shopManagement/tagManagement/tagManagement.vue"
export default component.exports